export default class {
  /**
   * Constructor should accept node to monitor
   * @param node
   */
  /* eslint-disable */
  constructor (node) {

  }

  /**
   * Function to be called when this monitor observes some form of change
   * @param callback
   */
  onChange (callback) {

  }

  stop () {

  }
}
